<app-detail-template>
  <div container-header>
    <retrieval-address-detail-header></retrieval-address-detail-header>
  </div>
  <div container-body>
    <router-outlet></router-outlet>
  </div>
</app-detail-template>
